// extracted by mini-css-extract-plugin
export default {"container":"CreateWorkspace_container__wVXQ7","sectionContainer":"CreateWorkspace_sectionContainer__dg5AS"};